import { render, staticRenderFns } from "./synopsis.vue?vue&type=template&id=292d30f4&scoped=true&"
import script from "./synopsis.vue?vue&type=script&lang=js&"
export * from "./synopsis.vue?vue&type=script&lang=js&"
import style0 from "./synopsis.vue?vue&type=style&index=0&id=292d30f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292d30f4",
  null
  
)

export default component.exports